import { render, staticRenderFns } from "./wxNewsDetail.vue?vue&type=template&id=a8be5b26&"
import script from "./wxNewsDetail.vue?vue&type=script&lang=js&"
export * from "./wxNewsDetail.vue?vue&type=script&lang=js&"
import style0 from "./wxNewsDetail.vue?vue&type=style&index=0&id=a8be5b26&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports